import ReverseOkIcon from './component'

export default ReverseOkIcon
